export class Step {
    /**
     * @param {string} name
     * @param {Number} index
     * @param nextHandler
     * @param enableBack
     */
    constructor(name, index, nextHandler = null, enterHandler = null, enableBack = true) {
        this.name = name;
        this.index = index;
        this.nextHandler = nextHandler;
        this.enterHandler = enterHandler;
        this.enableBack = enableBack;
    }
}
